function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "add");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "1_Artikel",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "1_Artikel_Artikel-Copy-3",
  transform: "translate(-280.000000, -146.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Artikel",
  transform: "translate(20.000000, 105.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "menu",
  transform: "translate(0.000000, 33.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "add",
  transform: "translate(260.000000, 8.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  stroke: "#2F3648",
  strokeWidth: 0.5,
  fillOpacity: 0.1,
  fill: "#FFFFFF",
  cx: 10,
  cy: 10,
  r: 9.75
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5555556,9.44444444 L15,9.44444444 C15.3068249,9.44444444 15.5555556,9.69317514 15.5555556,10 C15.5555556,10.3068249 15.3068249,10.5555556 15,10.5555556 L10.5555556,10.5555556 L10.5555556,15 C10.5555556,15.3068249 10.3068249,15.5555556 10,15.5555556 C9.69317514,15.5555556 9.44444444,15.3068249 9.44444444,15 L9.44444444,10.5555556 L5,10.5555556 C4.69317514,10.5555556 4.44444444,10.3068249 4.44444444,10 C4.44444444,9.69317514 4.69317514,9.44444444 5,9.44444444 L9.44444444,9.44444444 L9.44444444,5 C9.44444444,4.69317514 9.69317514,4.44444444 10,4.44444444 C10.3068249,4.44444444 10.5555556,4.69317514 10.5555556,5 L10.5555556,9.44444444 Z",
  id: "Combined-Shape",
  fill: "#FFD91F"
}))))));

var SvgAdd = function SvgAdd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add.cb495d89.svg";
export { ForwardRef as ReactComponent };